import { ThemeProvider, createTheme } from "@mui/material/styles";
import React, { useContext, useEffect } from "react";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
  useParams,
  useSearchParams,
  useLocation
} from "react-router-dom";

import './assests/css/style.css'

import { SnackbarProvider } from "notistack";
import Layout from "./components/layout";
import UserConversation from "./components/UserConversation.js";
import AiPlayground from "./pages/AI_playground";
import ForgotPassword from "./pages/authentication/ForgotPassword";
import Login from "./pages/authentication/Login";
import OTP from "./pages/authentication/OTP";
import PasswordReset from "./pages/authentication/PasswordReset";
import RequestOTP from "./pages/authentication/RequestOTP";
import Dashboard from "./pages/dashboard/index";
import PageNotFound from "./pages/Extra/PageNotFound";
import ScheduleMessage from "./pages/schedule_messages";
import TaskBoard from "./pages/TodoList/TaskBoard";
import { TasksListing } from "./pages/users/tasksListing";
import UserDetails from "./pages/users/UserDetails";
import UserListing from "./pages/users/UserListing";
import AuthContext from "./services/AuthContext";
import RedirectURL from "./pages/Extra/RedirectURL.js";
import Plans from "./pages/Payments/Plans.js";
import Checkout from "./pages/Payments/Checkout.js";
import PaymentDetails from "./pages/Payments/PaymentDetails.js";
import Success from "./pages/Payments/Success.js";
import Cancel from "./pages/Payments/Cancel.js";
import PaidUsers from "./pages/Payments/PaidUsers.js";
import RenderTemplate from "./components/JournalImageTemplate/TextTemplate/RenderTemplate.js";
import MemoryRender from "./pages/Memory_journal/MemoryRender.js";
import MyImageEditor1 from "./pages/Extra/MyImageEditor1.js";
import ActionMenu from "./pages/Extra/ActionMenu.js";
import VideoWithTransitions from "./pages/Extra/video.js";
import ShareButtons from "./pages/Extra/share.js";
import UIRecommendations from "./pages/UI_Recommendations/UIRecommendations.js";
import UIRecommendationsNew from "./pages/UI_Recommendations/UIRecommendationsNew.js"; //to remove later
import ChatBot from "./pages/Chatbot/ChatBot.js";
import ProductPage from "./pages/UI_Recommendations/ProductPage.js";
import ProductLinkRender from "./pages/UI_Recommendations/ProductLinkRender.js";
import TextrooLinkRender from "./pages/UI_Recommendations/TextrooLinkRender.js";
import TurnstileGate from "./components/common/Cloudfare.js";
import ShoppingList from "./pages/Shopping_list/ShoppingList.js";
import { KrogerCallback } from "./pages/Shopping_list/KrogerCallback.js";
import ShoppingListV2 from "./pages/Shopping_list/ShoppingListV2.js";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
  body: {
    fontFamily: "Poppins",
  },
});

function UserAutoLogin() {
  const [searchParams] = useSearchParams();
  const { login } = useContext(AuthContext);
  const { phoneNumber } = useParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const redirect_type = searchParams.get("type");
  const id = searchParams.get("id");

  useEffect(() => {
    const role = "user";
    if (token) {
      login(token, role);
      sessionStorage.setItem("phone", phoneNumber);
      if(redirect_type === "journal"){
        sessionStorage.setItem("redirect_type", "journal");
        navigate(`/user/${phoneNumber}/journal`);
      }
      else if(redirect_type === "shopping"){
        sessionStorage.setItem("redirect_type", "shopping");
        navigate(`/user/${phoneNumber}/shopping/${id}`);
      }
      else{
        sessionStorage.setItem("redirect_type", "tasks");
        navigate(`/user/${phoneNumber}`);
      }
    }
  }, [searchParams, login, phoneNumber]);

  if (!token) {
    sessionStorage.setItem("userRole", "user");
    return <RequestOTP />;
  }

  return null;
}

function App() {
  const HomeRedirect = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return isAuthenticated ? (
      <Navigate to="/admin/dashboard" replace />
    ) : (
      <Navigate to="/login" replace />
    );
  };

  const PublicRoute = () => {
    const { isAuthenticated } = useContext(AuthContext);
    return isAuthenticated ? (
      <Navigate to="/admin/dashboard" replace />
    ) : (
      <Outlet />
    );
  };

  const AuthGuard = ({ allowedRoles }) => {
    const { isAuthenticated, userRole } = useContext(AuthContext);
    const location = useLocation();
    const isUserRoute = location.pathname.includes("/user");


    if (!isAuthenticated) {
      const role = sessionStorage.getItem("userRole");
      const phone = sessionStorage.getItem("phone");
      if (role === "user" || isUserRoute) {
        return <Navigate to={`/user/${phone}/login`} replace />;
      } else {
        return <Navigate to="/login" replace />;
      }
    }

    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
  };

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        maxSnack={5}
        autoHideDuration={3000}
        SnackbarProps={{ preventDuplicate: true }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Router>
          <Routes>
            {/* Home Route Logic */}
            <Route path="/" element={<ChatBot />} />

            {/* Public Routes */}
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<Login />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/otp" element={<OTP />} />
              <Route path="/passwordReset" element={<PasswordReset />} />
              <Route path="/chatbot" element={<ChatBot tester={false}/>} />
              <Route path="/callback" element={<KrogerCallback />} />
              <Route path="/apptest" element={<ChatBot tester={true}/>} />

              <Route path=":phoneNumber/shopping/:id" element={<UIRecommendationsNew/>} />
              <Route path="/user/:phoneNumber/shopping/:id" element={<UIRecommendationsNew/>} />
              <Route path="/shopping/:phoneNumber/:id" element={<ProductLinkRender/>} />
              <Route path="/user/shopping/:phoneNumber/:id" element={<TextrooLinkRender/>} />
              <Route path="/user/shopping/:phoneNumber/:id/:adminView" element={<TextrooLinkRender/>} />


              <Route path="/shopping" element={<UIRecommendationsNew />} />
              <Route path="/stest" element={<ProductPage />} />
              <Route path="/cloudefare" element={<TurnstileGate />} />
              <Route path="/shoppingList" element={<ShoppingListV2 />} />
              <Route path="/user/shopping_list/:phoneNumber/:id" element={<ShoppingListV2 />} />
              <Route path="/user/shopping_list/:phoneNumber/:id/:adminView" element={<ShoppingListV2 />} />




            </Route>
            <Route path="/unauthorized" element={<PageNotFound />} />
            <Route
              path="/user/:phoneNumber/login"
              element={<UserAutoLogin />}
            />

            <Route path="/user/payment/plans/:phoneNumber" element={<Plans />} />

            <Route path="payments/:planName" element={<Checkout />} />

            <Route path="payments/success" element={<Success />} />
            <Route path="payments/cancel" element={<Cancel />} />


            <Route path="ui_recommendations/:phoneNumber/:id" element={<UIRecommendationsNew/>} />
            <Route element={<AuthGuard allowedRoles={["user"]} />}>
              <Route path="/user">
                <Route
                  path=":phoneNumber"
                  element={<TaskBoard access="user" type="all" />}
                />
              <Route path=":phoneNumber/journal" element={<MemoryRender />} />
              {/* <Route path=":phoneNumber/shopping/:id" element={<UIRecommendations/>} /> */}
               {/* <Route path=":phoneNumber/shopping2/:id" element={<UIRecommendationsNew/>} /> to remove later */}

              </Route>
            </Route>

            <Route path=":phoneNumber/journal" element={<MemoryRender />} />


            <Route path="/image1" element={<MyImageEditor1 />}></Route>
            <Route path="/image2" element={<ActionMenu />}></Route>
            <Route path="/video" element={<VideoWithTransitions />}></Route>
            <Route path="/share" element={<ShareButtons />}></Route>


            {/* Protected Routes */}
            <Route element={<AuthGuard allowedRoles={["admin"]} />}>
              <Route path="/admin" element={<Layout />}>
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="ai-playground" element={<AiPlayground />} />
                <Route path="schedule-messages" element={<ScheduleMessage />} />
                <Route path="insights" element={<Dashboard />} />
                <Route path="users" element={<UserListing />} />
                <Route path="user/:id" element={<UserDetails />} />
                <Route path="user/:id/tasks" element={<TasksListing />} />
                <Route path="test-environment" element={<UserConversation />} />
                <Route path="payments/:phone/:customerId/details" element={<PaymentDetails />} />
                <Route path="payment/plans" element={<Plans />} />
                <Route path="payments" element={<PaidUsers />} />
                <Route path="renderTemplate" element={<RenderTemplate />} />

              </Route>
            </Route>
            <Route path="/:code/:phoneNumber" element={<RedirectURL />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
